import { render, staticRenderFns } from "./交易数据.vue?vue&type=template&id=7f83725e&scoped=true"
import script from "./交易数据.vue?vue&type=script&lang=js"
export * from "./交易数据.vue?vue&type=script&lang=js"
import style0 from "./交易数据.vue?vue&type=style&index=0&id=7f83725e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f83725e",
  null
  
)

export default component.exports